module.exports = __webpack_public_path__ + "img/Stemness-INCA_10X_IC.24659e68.png";